import { NgModule } from '@angular/core';

import {SharedModule} from "../../shared/shared.module";
import {ManutencaoProgramadaListComponent} from "./manutencao-programada-list/manutencao-programada-list.component";
import {ManutencoesRoutingModule} from "../manutencoes-routing.module";
import {ManutencaoProgramadaApiService} from "./shared/manutencao-programada-api.service";
import {ManutencaoProgramadaNavigationService} from "./shared/manutencao-programada-navigation.service";
import {ManutencaoProgramadaService} from "./shared/manutencao-programada.service";
import {ManutencaoProgramadaComponent} from "./manutencao-programada.component";

@NgModule({
    imports: [
        SharedModule,
        ManutencoesRoutingModule
    ],
    providers: [
        ManutencaoProgramadaApiService,
        ManutencaoProgramadaNavigationService,
        ManutencaoProgramadaService
    ],
    declarations: [
        ManutencaoProgramadaComponent,
        ManutencaoProgramadaListComponent
    ]    
})
export class ManutencaoProgramadaModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/manutencao-programada/manutencao-programada.module.ts
 **/